import type { RefObject } from 'react';

import { useEffect, useRef, useState } from 'react';

export function useGridColumnCount<T extends HTMLElement = HTMLElement>(): [
  RefObject<T | null>,
  number,
] {
  const ref = useRef<T | null>(null);
  const [columnCount, setColumnCount] = useState(0);

  useEffect(() => {
    const element = ref.current;
    if (!element) {
      return;
    }

    const calculateColumnCount = () => {
      const computedStyle = window.getComputedStyle(element);
      const gridTemplateColumns = computedStyle.gridTemplateColumns;

      // gridTemplateColumns returns something like "200px 200px 200px" for 3 columns
      if (gridTemplateColumns && gridTemplateColumns !== 'none') {
        const columns = gridTemplateColumns.split(' ').filter((val) => val.trim() !== '');
        setColumnCount(columns.length);
      } else {
        setColumnCount(0);
      }
    };

    // Calculate initial column count
    calculateColumnCount();

    // Create ResizeObserver to track layout changes
    const resizeObserver = new ResizeObserver(() => {
      calculateColumnCount();
    });

    resizeObserver.observe(element);

    // Cleanup
    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return [ref, columnCount];
}
